<template>
    <div class="file-upload-drag">
        <div class="upload">
            <ul class="file-box" v-if="files.length">
                <li v-for="file in files" :key="file.id">
                    <span>{{file.name}}</span>
                    <span>({{formatSize(file.size)}})</span>
                    <span v-if="file.error"> - {{file.error}}</span>
                    <span v-else-if="file.success">success</span>
                    <span v-else-if="file.active">uploading...</span>
                    <span v-else></span>
                </li>
            </ul>
            <ul class="upload-box" v-else>
                <div class="text-center">
                    <h4>Drop file anywhere to upload<br/>or</h4>
                    <label for="file" class="btn btn-lg btn-primary">Select File</label>
                </div>
            </ul>

            <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                <h3>Drop files to upload</h3>
            </div>

                <file-upload
                    class="btn btn-primary"
                    :post-action="postAction"
                    :extensions="extensions"
                    :multiple="false"
                    :drop="true"
                    :drop-directory="false"
                    :data="dataObj"
                    @input-file="inputFile"
                    v-model="files"
                    ref="upload">
                </file-upload>

        </div>
            <button type="button" class="btn btn-success btn-start-upload"
                    v-if="files.length !== 0 && !disableButton"
                    @click.prevent="buttonClicked">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                Start Upload
            </button>
    </div>
</template>


<script>
import FileUpload from 'vue-upload-component'
import {EventBus} from "../../EventBus";

export default {
    props: {
        postAction: String,
        data: String,
        extensions: String,
        fileType: {
            type: String,
            default: ''
        },
        emitFunction:{
            type: String,
            default: ''
        },
    },
    components: {
        FileUpload,
    },
    data() {
        return {
            maxFileSize: 1024 * 1024 * 3, // 3mb
            files: [],
            dataObj: JSON.parse(this.data),
            disableButton: false,
        }
    },
    methods: {
        formatSize: function(size) {
            if (size > 1024 * 1024) {
                return (size / 1024 / 1024).toFixed(2) + ' MB'
            } else if (size > 1024) {
                return (size / 1024).toFixed(2) + ' KB'
            }
            return size.toString() + ' B'
        },
        buttonClicked: function () {
            this.$refs.upload.active = true;
        },
        inputFile(newFile, oldFile) {
            if (newFile && !oldFile) {
                if (newFile.size >= 0 && newFile.size > this.maxFileSize) {
                    newFile = this.$refs.upload.update(newFile, {error: 'Max filesize is 3mb'})
                }

                if (newFile.type !== this.fileType){
                    newFile = this.$refs.upload.update(newFile, {error: 'File extension must be ' + this.extensions})
                }
            }
            if (newFile && oldFile) {
                // Uploaded successfully
                if (newFile.success !== oldFile.success) {
                    this.disableButton = true;

                    if(this.emitFunction.length > 0)
                    EventBus.emit(this.emitFunction);
                }
            }

        }

    }
}
</script>

<style>
.file-upload-drag{
    text-align: center;
}
.file-upload-drag label.btn {
    margin-right: 1rem;
}
.file-upload-drag label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
}

.file-upload-drag .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
}
.file-upload-drag .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
}
.file-upload-drag .upload {
    background: #c6e8f0;
    border: 2px dashed;
}
.file-upload-drag .upload ul.upload-box {
    margin: auto;
    width: 23rem;
    padding: 1rem 0 2rem 0;

}
.upload span.file-uploads-html5{
    display: none;
}

button.btn-start-upload{
    margin: 3rem 1rem 0 0;
    width: 22rem;
}
.upload ul.file-box{
    font-size: 2rem;
    text-decoration: none;
    list-style-type: none;
    padding: 4rem;
}
</style>
